import React from 'react';
import Prices from "components/Prices";

interface ModalContentProps {
  selectedOrder: any; // Define el tipo de los datos de la orden
  handleCloseModal: () => void; // Define el tipo de la función para cerrar el modal
  totalPagesProducts: any; // Define el tipo de los datos de la orden
  renderPaginationButtonsProducts: () => JSX.Element[]; // Define el tipo de la función para cerrar el modal
}

const ModalContent: React.FC<ModalContentProps> = ({ selectedOrder, handleCloseModal, totalPagesProducts, renderPaginationButtonsProducts }) => {
  return (
    <>
      {/* Backdrop: scrollea él, no el modal */}
      <div className="fixed inset-0 z-50 overflow-y-auto overscroll-contain bg-black/50">
        <div className="flex min-h-full items-center justify-center p-4">
          {/* Caja: alto máximo + columna para que solo el cuerpo scrollee */}
          <div className="flex max-h-[90dvh] w-full max-w-2xl flex-col overflow-hidden rounded-lg bg-white shadow-xl">
            {selectedOrder && (
              <>
                <div className="px-4 pt-6 md:px-10 md:pt-10">
                  <h3 className="mb-4 text-xl font-semibold">Detalles de la orden:</h3>
                </div>

                {/* Cuerpo scrolleable */}
                <div className="flex-1 overflow-y-auto px-4 md:px-10">
                  <div className="flex flex-col gap-4">
                    {selectedOrder.map((product: any, index: number) => (
                      <div
                        key={index}
                        className="flex items-center gap-4 rounded-lg border border-gray-300 px-3 py-4 sm:py-7 md:px-6"
                      >
                        {/* Tamaño fijo, sin flex-[.5] */}
                        <div className="h-24 w-16 shrink-0 overflow-hidden rounded-xl bg-slate-100 sm:w-20">
                          <img
                            src={`https://api.yosoymitzen.com/StaticFiles/ProductsImg/${product.imageName}`}
                            alt={product.productName}
                            className="h-full w-full object-contain object-center"
                          />
                        </div>

                        {/* min-w-0 es la clave */}
                        <div className="flex min-w-0 flex-1 flex-col gap-5">
                          <div className="flex min-w-0 flex-col items-start justify-between gap-1 sm:flex-row sm:items-center">
                            <h3 className="min-w-0 flex-1 truncate text-base font-medium">
                              {product.productName}
                            </h3>
                            <Prices price={product.subtotalNetAmount} className="ml-0 shrink-0 sm:ml-2" />
                          </div>

                          <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
                            <p className="text-sm text-gray-500 dark:text-slate-400">
                              <strong>Cantidad:</strong> {product.quantity}
                            </p>
                            <div className="flex min-w-0 flex-col text-sm md:text-right">
                              <span className="break-words font-medium text-indigo-600 dark:text-primary-500">
                                <strong>Puntos Reales:</strong> {product.subtotalPoints} pts.
                              </span>
                              <span className="break-words font-medium text-indigo-600 dark:text-primary-500">
                                <strong>Puntos de Red:</strong> {product.subtotalPointsNetwork} pts.
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}

                    {totalPagesProducts > 1 && (
                      <div className="mt-4 flex flex-wrap justify-center gap-2">
                        {renderPaginationButtonsProducts()}
                      </div>
                    )}
                  </div>
                </div>

                {/* Footer fijo */}
                <div className="flex justify-end border-t border-gray-200 px-4 py-4 md:px-10">
                  <button
                    className="rounded-md bg-blue-500 px-4 py-2 text-white hover:bg-blue-600"
                    onClick={handleCloseModal}
                  >
                    Cerrar
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ModalContent;
